
if(!__webpack_require__.federation){
    __webpack_require__.federation = {
        
chunkMatcher: function(chunkId) {
    return !/^(1160|3343|7049|7813)$/.test(chunkId);
},
rootOutputDir: "../../",

    };
}
